export default "__VITE_ASSET__BLoKkwQ6__"